export const useCryptoCurrencies = () => {
    const currencies = {
        _data: [],
        set value(v) {
            this._data = v;
        },
        get value() {
            return this._data;
        },
    };
    const networks = window.Alpine.reactive({
        _data: [],
        set value(v) {
            this._data = Array.isArray(v) ? v : [];
        },
        get value() {
            return this._data;
        },
    });
    const selected = window.Alpine.reactive({
        _value: null,
        _network: null,
        set value(v) {
            const _currency = currencies.value.find((c) => c.value == v);
            if (_currency) {
                this._value = _currency;
                networks.value = _currency.networks;
                if (_currency.networks.length > 0) {
                    this._network = _currency.networks[0];
                }
            } else {
                this._value = null;
                this._network = null;
                networks.value = [];
            }
        },
        get value() {
            return this._value;
        },
        get network() {
            return this._network;
        },
        set network(n) {
            const _net = networks.value.find((c) => c.value === n);
            this._network = _net ?? null;
        },
    });

    return {
        currencies,
        selected,
        networks,
    };
};
